export const global = {
    managerURL: "https://backend2025.digitalheads.ar",
};